import React, { Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import fileDownload from 'js-file-download';

export default class RowItemLichSuXuLy extends Component {

  getTaiLieu() {
    const {listTaiLieuVanThus} = this.props.item || [];
    const tenFile = listTaiLieuVanThus.length > 0 && listTaiLieuVanThus.map((item, index) => {
      return (
        <div className="pd5" key={index}>
          <Link onClick={fileDownload.bind(this, item.duongDan, item.tenFile)} className='txt-underline txt-blue'>{item.tenFile || ''}</Link>
        </div>
      );
    });
    return tenFile;
  }

  render() {
    const { lanXuLy, soQuyetDinh, ngayBanHanh, namThanhTra, thoiGianXuLy, listTaiLieuVanThus } = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{lanXuLy || ''}</td>
        <td>{soQuyetDinh || ''}</td>
        <td>{ngayBanHanh ? moment(ngayBanHanh).format('DD/MM/YYYY') : ''}</td>
        <td>{namThanhTra || ''}</td>
        <td>{moment(thoiGianXuLy).format('DD/MM/YYYY') || ''}</td>
        <td>
          {
            this.getTaiLieu()
          }
        </td>
        <td>
          <Link to={'/thanh-tra/noi-dung-xu-ly/chi-tiet/' + this.props.item.lichSuXuLyCTTId} className='txt-underline txt-blue'>Xem chi tiết</Link>
        </td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/RowItemLichSuXuLy.jsx